// Copyright 2020 Sorama B.V.

import { bindable, customElement, inject } from "aurelia-framework";
import { IWorkflowModuleCatalog } from "catalogs/IWorkflowModuleCatalog";
import { HelpWorkflowModuleCatalog } from "catalogs/WorkflowModuleCatalog/HelpWorkflowModuleCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { SidebarRouter } from "libraries/WorkflowFramework/Sidebar/SidebarRouter";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import tippy, { Instance, Props } from "tippy.js";

@customElement("guidance-tooltip")
@inject(Element, IWorkflowModuleCatalog, ShellViewManager)
export class GuidanceTooltip {
    @bindable
    private text: string;

    @bindable
    private topic: string;

    private tooltip: HTMLDivElement;
    private tippyInstances: Instance<Props>;

    constructor(
        private readonly element: HTMLElement,
        private readonly catalog: IWorkflowModuleCatalog,
        private readonly shellviewManager: ShellViewManager
    ) {}

    private bind() {
        this.tippyInstances = tippy(this.element, {
            content: this.tooltip,
            theme: "guidance",
            interactive: this.topic ? true : false,
            appendTo: document.body,
        });
    }

    private unbind() {
        if (this.tippyInstances) {
            this.tippyInstances.destroy();
        }
    }

    public navigateToTopic(): void {
        const mod = this.catalog.getWorkflowModules(WorkflowModuleType.Help).find((x) => x.name == this.topic);

        if (mod) {
            this.shellviewManager.openRightSideBar(HelpWorkflowModuleCatalog.HelpModule, [
                {
                    prefix: SidebarRouter.prefix,
                    name: "topicName",
                    value: this.topic,
                },
            ]);
        }
    }
}
